import React, { useEffect, useState } from 'react';
import './styles.css';

import {
  Button,
  ButtonGroup,
  FormControlLabel,
  Switch,
  TextField,
} from '@material-ui/core';

const AddNewMonthForm = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState({
    month: 1,
    active: false,
    discountActive: false,
    discount: 0,
    discountString: '0%',
  });

  const handleChange = (e: any) => {
    if (e.target.name === 'discount') {
      if (
        Number(e.target.value) <= 100 &&
        Number(e.target.value) >= 0 &&
        !String(e.target.value).includes('-') &&
        !String(e.target.value).includes('+')
      ) {
        setItem({
          ...item,
          [e.target.name]: Number(e.target.value),
        });
      } else if (!String(e.target.value).length) {
        setItem({
          ...item,
          [e.target.name]: 0,
        });
      }
      return;
    } else {
      setItem({
        ...item,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleChangeStatus = (e: any) => {
    setItem({ ...item, active: e.target.checked });
  };
  const handleChangeBonusStatus = (e: any) => {
    setItem({
      ...item,
      discountActive: e.target.checked,
    });
  };

  return (
    <div className='add-new-month-form'>
      <div className='content'>
        <div className='row'>
          <div className='col'>
            <FormControlLabel
              control={
                <Switch checked={item.active} onChange={handleChangeStatus} />
              }
              label={item.active ? 'Active' : 'Disabled'}
            />
          </div>
          <div className='col'>
            <TextField
              className='edit-field'
              size='small'
              required
              label='Period'
              name='month'
              type='number'
              variant='outlined'
              onChange={handleChange}
              value={item.month}
              inputProps={{ step: 1, min: 1 }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='month-bundle-inner'>
            <FormControlLabel
              control={
                <Switch
                  checked={item.discountActive}
                  onChange={handleChangeBonusStatus}
                />
              }
              label={item.discountActive ? 'Active' : 'Disabled'}
            />
          </div>
          <div className='month-bundle-inner'>
            <TextField
              className='edit-field'
              size='small'
              required
              label='Discount'
              name='discount'
              type='number'
              variant='outlined'
              onChange={handleChange}
              value={item.discount}
              InputProps={{
                inputProps: { step: 1, max: 100, min: 0 },
              }}
            />
          </div>
          <div className='month-bundle-inner'>
            <TextField
              className='edit-field'
              size='small'
              required
              label='Text'
              name='discountString'
              variant='outlined'
              onChange={handleChange}
              value={item.discountString}
            />
          </div>
        </div>
      </div>
      <div className='buttons'>
        <ButtonGroup variant='contained' aria-label='outlined button group'>
          <Button
            size='small'
            color='primary'
            onClick={async () => {
              setIsLoading(true);
              await props.onSubmit(item);
              setIsLoading(false);
            }}
            disabled={isLoading}
          >
            Save
          </Button>
          <Button
            size='small'
            color='primary'
            onClick={() => {
              props.onCancel();
            }}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default AddNewMonthForm;
